module.exports = __webpack_public_path__ + "img/mypic.94720c4.webp";